
class Unit {
    constructor(id, setting, template) {
        id && this.setId(id)
        setting && this.setSetting(setting)
        template && this.setTemplate(template)
    }

    setId(id) {
        this.id = id
    }

    setSetting(setting) {
        this.setting = setting
    }

    setTemplate(tpl) {
        this.template = tpl
    }
}
export default Unit